import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-price-list',
    templateUrl: './price-list.component.html',
    styleUrls: ['./price-list.component.scss'],
    standalone: false
})
export class PriceListComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
